module.exports = __webpack_public_path__ + "img/console.ddaadbe2.png";